import React, { useRef } from 'react';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Title,
  Stack,
  Button,
  Group
} from '@mantine/core';
import { Link } from 'react-router-dom';

import ClientList from '../components/client/ClientList';

const ManageClients: React.FC = () => {
  const activeClientsRefetchRef = useRef<(() => void) | null>(null);
  const inactiveClientsRefetchRef = useRef<(() => void) | null>(null);

  const handleRefetchAll = () => {
    // Refetch both lists when any agent-related action occurs
    if (activeClientsRefetchRef.current) {
      activeClientsRefetchRef.current();
    }
    if (inactiveClientsRefetchRef.current) {
      inactiveClientsRefetchRef.current();
    }
  };

  return (
    <>
      <Group justify="space-between" mb="xl">
        <Title order={1}>Manage Clients</Title>
        <Button
          component={Link}
          leftSection={<FontAwesomeIcon icon={faPlus} />}
          to="/client/add"
          variant="filled"
        >
          Add Client
        </Button>
      </Group>
      
      <Stack gap="xl">
        {/* Active Clients Section */}
        <ClientList
          isActive={true}
          title="Active Clients"
          onAgentAction={handleRefetchAll}
          onRefetchReady={(refetch: () => void) => {
            activeClientsRefetchRef.current = refetch;
          }}
        />

        {/* Inactive Clients Section */}
        <ClientList
          isActive={false}
          title="Inactive Clients"
          onAgentAction={handleRefetchAll}
          onRefetchReady={(refetch: () => void) => {
            inactiveClientsRefetchRef.current = refetch;
          }}
        />
      </Stack>
    </>
  );
};

export default ManageClients;
